import { render, staticRenderFns } from "./CriarPonto.vue?vue&type=template&id=587cfd4a&scoped=true&"
import script from "./CriarPonto.vue?vue&type=script&lang=js&"
export * from "./CriarPonto.vue?vue&type=script&lang=js&"
import style0 from "./CriarPonto.vue?vue&type=style&index=0&id=587cfd4a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "587cfd4a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VFileInput } from 'vuetify/lib/components/VFileInput';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';
installComponents(component, {VBtn,VChip,VCol,VContainer,VFileInput,VRow,VSelect,VSnackbar})
